export default __webpack_public_path__ + "static/media/Ônibus Fill.e422b379.svg";